module.exports = __webpack_public_path__ + "img/icon-back.a81e34e5.svg";